import { render, staticRenderFns } from "./p16.vue?vue&type=template&id=58c84d83&scoped=true&"
import script from "./p16.vue?vue&type=script&lang=js&"
export * from "./p16.vue?vue&type=script&lang=js&"
import style0 from "./p16.vue?vue&type=style&index=0&id=58c84d83&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c84d83",
  null
  
)

export default component.exports